export default     {
    prompt:"Background?",
    field:"customBackground",
    type:"childStyle",
    child:".main-cont",
    valueType:"string",
    colorPicker:true,
    default:"inherit",
    property:"background",
}